import { getApiGalaxyServer } from 'services';

export interface IntegrationMetadataEntry {
  externalDocsUrl: string | null;
  internalDocsUrl: string | null;
  githubRepoUrl: string | null;
  runbookUrl: string | null;
  grafanaDashboardUrl: string | null;
}

/**
 * Response shape from galaxy-server `GET /integrations_api/metadata`.
 * Keys are targetService strings; values are the per-integration metadata entry.
 */
export type IntegrationMetadataResponse = Record<string, IntegrationMetadataEntry>;

export interface GetIntegrationMetadataParams {
  /**
   * Optional scope — when supplied, the backend echoes only the entry for this
   * service (and only if it matches a key in the loaded config). Omit to fetch
   * the full map.
   */
  targetService?: string;
}

export const getIntegrationMetadataApi = ({
  params,
  token,
  config = {},
}: BaseApiParams<GetIntegrationMetadataParams>) => {
  const queryParams = params?.targetService ? { targetService: params.targetService } : undefined;
  return getApiGalaxyServer<IntegrationMetadataResponse>(
    `/integrations_api/metadata`,
    { ...config, ...(queryParams ? { params: queryParams } : {}) },
    token,
  );
};
